import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ThemeIcon, useMantineTheme } from "@mantine/core";

import { Severity } from "@protos/common/v1/common";
import { getSeverityColorScheme } from "@shared/utils";

export interface SeverityIconProps {
  severity: Severity;
}

export const SeverityIcon: FC<SeverityIconProps> = ({ severity }) => {
  const { colors } = useMantineTheme();
  const { color, iconShade } = getSeverityColorScheme(colors, severity);

  // show only the first character of the human-readable severity name (e.g. "SEVERITY_HIGH" => "H")
  const { t } = useTranslation("protos");
  const severityIconLabel = t(severity)[0];

  return (
    <ThemeIcon
      color={color[iconShade]}
      radius="xl"
      size="sm"
      fz="xs"
      fw="bold"
      lh={1}
    >
      {severityIconLabel}
    </ThemeIcon>
  );
};
